import { render } from "./EditCandidate.vue?vue&type=template&id=03dc94a7"
import script from "./EditCandidate.vue?vue&type=script&lang=js"
export * from "./EditCandidate.vue?vue&type=script&lang=js"
script.render = render

export default script